export const SellerRepresentative = Object.freeze({
    FREELANCER: 'freelancer',
    AGENCY: 'agency',
});
